
const {ccclass, property} = cc._decorator;

@ccclass
export default class JdDealerComponent extends cc.Component {

    private animName:string[] = [];
    private index:number = 0;

    @property(dragonBones.ArmatureDisplay)
    dragonBone:dragonBones.ArmatureDisplay = null;

    onEnable(){
        this.doDealerAnim();
        this.schedule(this.doDealerAnim.bind(this),5,Number.MAX_VALUE)
    }

    onLoad(){
        this.animName.push('blink2');
        this.animName.push('static');
    }

    doDealerAnim(){
        let random = Math.random();
        let animIndex = 0;
        if (random <= 0.4) {
            animIndex = 1;
        }
        this.playAnim(this.animName[animIndex]);
    }

    private playAnim(name:string){
        this.dragonBone.playAnimation(name,1);
    }

}
